// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__Pr-Ns","titleBlock":"PageHeader_titleBlock__Cb3SE","actions":"PageHeader_actions__-XzKX"};